import { Text, View } from '@react-pdf/renderer';

import { salesComparisonPageStyles as styles } from '../styles.ts';
import type { SalesComparisonGridColumnData, SalesComparisonRows } from '../types.ts';
import { buildSalesComparisonGlossaryText } from '../utils/buildSalesComparisonGlossaryText.ts';

export const SalesComparisonGlossary = ({
  filteredRows,
  properties,
}: {
  filteredRows: SalesComparisonRows;
  properties: SalesComparisonGridColumnData[];
}) => {
  const text = buildSalesComparisonGlossaryText(filteredRows, properties);
  if (!text) return null;

  return (
    <View style={styles.glossary}>
      <Text style={styles.glossaryText}>{text}</Text>
    </View>
  );
};
